/**
 * MED-770: Task deep link URL generation and clipboard helpers
 */
import { notifications } from '@mantine/notifications';

/**
 * Build a shareable URL that deep-links to a specific task's detail drawer.
 *
 * Cohort-scoped:  /cohorts/{cohortId}?tab=tasks&taskId={taskId}
 * Cross-cohort:   /tasks?taskId={taskId}&cohortId={cohortId}
 */
export function buildTaskLink(taskId: string, cohortId: string, context: 'cohort' | 'cross-cohort' = 'cohort'): string {
  const base = window.location.origin;
  if (context === 'cross-cohort') {
    return `${base}/tasks?taskId=${encodeURIComponent(taskId)}&cohortId=${encodeURIComponent(cohortId)}`;
  }
  return `${base}/cohorts/${encodeURIComponent(cohortId)}?tab=tasks&taskId=${encodeURIComponent(taskId)}`;
}

/**
 * Copy a task deep link to the clipboard and show a toast notification.
 */
export function copyTaskLink(taskId: string, cohortId: string, context: 'cohort' | 'cross-cohort' = 'cohort'): void {
  const url = buildTaskLink(taskId, cohortId, context);
  navigator.clipboard.writeText(url).then(() => {
    notifications.show({
      title: 'Link copied',
      message: 'Task link copied to clipboard',
      color: 'green',
      autoClose: 2000,
    });
  }).catch(() => {
    notifications.show({
      title: 'Copy failed',
      message: 'Could not copy link to clipboard',
      color: 'red',
    });
  });
}
